// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition24Filled: FC<Recognition24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12.484 1.598a8.2 8.2 0 0 1 8.2 8.2 8.162 8.162 0 0 1-1.758 5.07l2.732 4.73-4.218.577-2.61 3.364-2.346-4.065-2.347 4.065-2.61-3.364-4.217-.578 2.73-4.73a8.163 8.163 0 0 1-1.756-5.069 8.2 8.2 0 0 1 8.2-8.2ZM6.53 18.02l2.078.285 1.284 1.656 1.203-2.083a8.157 8.157 0 0 1-3.582-1.56L6.53 18.02Zm10.925-1.703a8.156 8.156 0 0 1-3.583 1.561l1.203 2.083 1.286-1.656 2.077-.286-.983-1.702Zm-6.053-5.62L9.574 8.869 8.16 10.283l3.242 3.242 5.196-5.196-1.414-1.414-3.782 3.782Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Recognition24Filled;
